import { useRootStore } from 'stores/RootStore'

/**
 * Returns the current subscription from TierUsageStore.
 * The data is fetched once when the app loads via TieredUsageListener.
 */
export const useCurrentPlan = () => {
  const tierUsageStore = useRootStore().tierUsageStore

  return {
    data: tierUsageStore.currentSubscription,
    isLoading: tierUsageStore.loading,
    isFetched: tierUsageStore.initialized,
    isInitialized: tierUsageStore.initialized,
  }
}
